import Http from './http'
// import {The_Ability} from '../store/index'

export default {
	// index(filter){
  //   return Http.get(`/qr_codes`, {params: {...filter}})
  // },
  
  // show(id){
  //   return Http.put(`/qr_codes/${id}`)
  // },

  createFromApiKey(qr_code){
    let {id, token} = qr_code
    let obj = {api_key_id: id, tk: token}
    return Http.post(`/gen_qr_codes.png`, {
      qr_code: {...obj}
    },
    { responseType: 'blob' }
    )
  }
}